import { METABASE_SESSION_LOG_URL } from "@olivahealth/constants";
import UserRole from "@olivahealth/business/src/Core/domain/value-objects/UserRole";
import { NavbarLink, NavbarLinkType } from "@olivahealth/oli-ui";
import { TFunction } from "../../../hooks/useTranslation";

/**
 * Returns the list of admin navigation links.
 * This is a shared source of truth used by both Navbar and WorkSidebar.
 */
export function getAdminLinks(
  t: TFunction,
  googleDriveIntegrationEnabled = false,
): NavbarLink[] {
  const links: NavbarLink[] = [
    {
      activeRegex: "/admin/triaging-submissions",
      href: "/admin/triaging-submissions",
      label: t("matchingTool"),
      role: [
        UserRole.ADMIN,
        UserRole.CLINICAL_SUPERVISOR,
        UserRole.EXTERNAL_CLINICAL_SUPERVISOR,
      ],
      type: NavbarLinkType.ADMIN,
      id: "navbar-link-matching-tool",
    },
    {
      activeRegex: "/admin/organisation-reports",
      href: "/admin/organisation-reports",
      label: t("organisationReports"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
      id: "navbar-link-organisation-reports",
    },
    {
      href: METABASE_SESSION_LOG_URL,
      isExternal: true,
      label: t("sessionsLog"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/detailed-professional-availability",
      href: "/admin/detailed-professional-availability",
      label: t("professionalAvailability"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/case-management",
      href: "/admin/case-management",
      label: t("caseManagement"),
      role: [
        UserRole.ADMIN,
        UserRole.CLINICAL_SUPERVISOR,
        UserRole.EXTERNAL_CLINICAL_SUPERVISOR,
      ],
      type: NavbarLinkType.ADMIN,
      id: "navbar-link-case-management",
    },
    {
      activeRegex: "/admin/chat-management",
      href: "/admin/chat-management",
      label: t("chatManagement"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/impersonate",
      href: "/admin/impersonate",
      label: t("impersonate"),
      role: [UserRole.IMPERSONATOR],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/instant-session",
      href: "/admin/instant-session",
      label: t("instantSession"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/conversation-starters",
      href: "/admin/conversation-starters",
      label: t("conversationStarters"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/signals",
      href: "/admin/signals",
      label: t("signals"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/personal-challenges",
      href: "/admin/personal-challenges",
      label: t("personalChallenge"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/slack-channels",
      href: "/admin/slack-channels",
      label: t("slackChannels"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/send-slack-comms",
      href: "/admin/send-slack-comms",
      label: t("sendSlackComms"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
    },
    {
      activeRegex: "/admin/organisation-objectives",
      href: "/admin/organisation-objectives",
      label: t("organisationObjectives"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
      id: "navbar-link-organisation-objectives",
    },
    {
      activeRegex: "/admin/dsar-export",
      href: "/admin/dsar-export",
      label: t("dsarExport"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
      id: "navbar-link-dsar-export",
    },
    {
      activeRegex: "/admin/dsar-deletion",
      href: "/admin/dsar-deletion",
      label: t("dsarDeletion"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
      id: "navbar-link-dsar-deletion",
    },
  ];

  if (googleDriveIntegrationEnabled) {
    links.push({
      activeRegex: "/admin/drive-digests",
      href: "/admin/drive-digests",
      label: t("digests"),
      role: [UserRole.ADMIN],
      type: NavbarLinkType.ADMIN,
      id: "navbar-link-digests",
    });
  }

  return links;
}
